// Einheitliches Platzhalterbild («Foto folgt») für alle Stellen, an denen eine
// Aktivität, ein Deal oder eine Tour kein eigenes Bild hat.
export const PLACEHOLDER_IMAGE =
  'https://media.base44.com/images/public/697f22bb3d0fcd8d62b322bf/37d60a2c7_placeholder.png';